import { createBrowserRouter, Navigate } from 'react-router-dom';
import usePages from './use-pages';
import AuthorizedComponent from '../components/authorized-component';
import CacheBuster from '../components/CacheBuster';
import ErrorContextProvider from '../contexts/error-context-provider';
import Layout from '../layout';
import LoginVerifyPage from '../pages/authentication/login-verify.page';
import LoginPage from '../pages/authentication/login.page';
import LogoutPage from '../pages/authentication/logout.page';

const useRouter = (): any => {
  const pages = usePages();

  return createBrowserRouter([
    {
      path: '/login',
      element: (
        <CacheBuster>
          <ErrorContextProvider>
            <LoginPage />
          </ErrorContextProvider>
        </CacheBuster>
      ),
    },
    {
      path: '/verify',
      element: (
        <CacheBuster>
          <ErrorContextProvider>
            <LoginVerifyPage />
          </ErrorContextProvider>
        </CacheBuster>
      ),
    },
    {
      path: '/logout',
      element: (
        <CacheBuster>
          <ErrorContextProvider>
            <LogoutPage />
          </ErrorContextProvider>
        </CacheBuster>
      ),
    },
    {
      path: '/',
      errorElement: <Navigate to={'/'} />,
      element: (
        <CacheBuster>
          <AuthorizedComponent>
            <ErrorContextProvider>
              <Layout />
            </ErrorContextProvider>
          </AuthorizedComponent>
        </CacheBuster>
      ),
      children: Object.entries(pages).map(([key, value]) => ({
        element: value.element,
        path: key.substring(1),
        children: value.children,
      })),
    },
  ]);
};

export default useRouter;
